import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@sessions.rpc`,
    services: {
        roster_members: {
            parameters: [
                { name: 'session_id', type: 'integer', optional: false },
                { name: 'select', type: 'object', optional: true }
            ]
        }
    }
});
export default svc;
